import type { Video } from "@/types/video";
import { getEpisodeLabel } from "@/lib/videoData";

interface EpisodeListProps {
  video: Video;
  current: number;
  onChange: (episode: number) => void;
}

export default function EpisodeList({ video, current, onChange }: EpisodeListProps) {
  if (video.episodeCount <= 0) return null;

  const label = getEpisodeLabel(video);
  const episodes = Array.from({ length: video.episodeCount }, (_, index) => index + 1);

  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-play-list-2-line text-lg text-primary-600" />
          选集列表
          <span className="rounded bg-background-100 px-1.5 py-0.5 text-[10px] font-medium text-foreground-600">
            共 {video.episodeCount} {label}
          </span>
        </h2>
        <p className="text-[11px] text-foreground-500">
          当前播放：第 {current} {label} · {video.status}
        </p>
      </div>

      <div className="no-scrollbar mt-3 max-h-[220px] overflow-y-auto pr-0.5">
        <div className="grid grid-cols-5 gap-2 sm:grid-cols-8 md:grid-cols-10">
          {episodes.map((episode) => {
            const active = episode === current;
            return (
              <button
                key={episode}
                type="button"
                onClick={() => onChange(episode)}
                aria-current={active ? "true" : undefined}
                className={`flex h-9 cursor-pointer items-center justify-center rounded-md text-xs font-semibold transition-colors ${
                  active
                    ? "bg-accent-500 text-foreground-950"
                    : "bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-700"
                }`}
              >
                {episode}
              </button>
            );
          })}
        </div>
      </div>

      <p className="mt-3 text-[11px] text-foreground-500">
        提示：切换{label}数会同步更新上方演示播放器的标题与进度，均为前端演示效果。
      </p>
    </section>
  );
}